const actions = {
  //Listar Transferencias
  listarTransferencias: async (
    context,
    {
      data_inicial,
      status,
      vendor_id_out,
      vendor_id_in,
      data_final,
      numero,
      page,
      per_page,
      transaction_type,
      movimentou_estoque,
      produto,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`transferencia-estoque`, {
      params: {
        data_inicial,
        data_final,
        status,
        vendor_id_out,
        vendor_id_in,
        numero,
        page,
        per_page,
        transaction_type,
        movimentou_estoque,
        produto,
      },
    });

    return response;
  },

  listarTransferenciaMrp: async (
    context,
    {
      vendor_id,
      compra_sugerida = 0,
      per_page,
      page,
      search,
      compra_em_aberto,
      stock,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;

    const response = await api.get(`/vendors/reports/mrp`, {
      params: {
        per_page,
        vendor_id,
        page,
        compra_sugerida,
        search,
        compra_em_aberto,
        stock,
      },
    });

    return response;
  },

  criarTransferencia: async (
    context,
    { deposito_id_entrada, deposito_id_saida }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`transferencia-estoque`, {
      deposito_id_entrada,
      deposito_id_saida,
    });

    return response;
  },

  deletarTransferencia: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.delete(`transferencia-estoque/${id}`, {
      id,
    });

    return response;
  },
  //Detalhe Transferencia
  detalharTransferencia: async (context, { id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`transferencia-estoque/${id}`);

    return response;
  },

  alterarNecessidade: async (
    context,
    { id_transferencia, necessidade_numero }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(
      `transferencia-estoque/${id_transferencia}`,
      {
        id_transferencia,
        necessidade_numero,
      }
    );

    return response;
  },

  listagemDetalhada: async (context, { id, per_page }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`transferencia-estoque/listagem/detalhada`, {
      params: {
        id,
        per_page,
      },
    });

    return response;
  },

  listarUsuarios: async (context, { per_page, search, vendor_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`auth/users`, {
      params: {
        per_page,
        search,
        vendor_id,
      },
    });

    return response;
  },

  listarProdutosEstoque: async (
    context,
    {
      abaixo_reposicao_destino,
      vendor_id_destino,
      vendor_id_origem,
      produto,
      grupo,
    }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`transferencia-estoque/listagem/produtos`, {
      params: {
        abaixo_reposicao_destino,
        vendor_id_destino,
        vendor_id_origem,
        produto,
        grupo,
      },
    });

    return response;
  },

  adicionarProduto: async (
    context,
    { id_transferencia, action, produtos, transferir_estoque }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(
      `transferencia-estoque/${id_transferencia}/adicionar-produto`,
      {
        action,
        produtos,
        transferir_estoque,
      }
    );

    return response;
  },

  removerProduto: async (context, { id_transferencia, action, produtos }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(
      `transferencia-estoque/${id_transferencia}/remover-produto`,
      {
        action,
        produtos,
      }
    );

    return response;
  },

  alterarSolicitante: async (context, { id_transferencia, solicitante_id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(
      `transferencia-estoque/${id_transferencia}`,
      {
        solicitante_id,
      }
    );

    return response;
  },
  alterarSeparador: async (
    context,
    { id_transferencia, responsavel_separacao_id }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(
      `transferencia-estoque/${id_transferencia}`,
      {
        responsavel_separacao_id,
      }
    );

    return response;
  },

  alterarEstadoTransferencia: async (
    context,
    { action, id_transferencia, produtos, manipulador }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(
      `transferencia-estoque/${id_transferencia}/${action}`,
      {
        produtos,
        manipulador,
      }
    );

    return response;
  },

  valoresInvertidos: async (
    context,
    { descricao, id, somente_itens_divergentes }
  ) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.post(`transferencia-estoque/invertido`, {
      descricao,
      id,
      somente_itens_divergentes,
    });

    return response;
  },

  listarGruposProduto: async (context, { unidade, per_page, page, search }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.get(`/product-groups`, {
      params: {
        page,
        per_page,
        vendor_id: unidade,
        search,
      },
    });

    return response;
  },
  //Impressão Transferencia
  alterarDescricao: async (context, { descricao, id }) => {
    const api = context.rootState.autenticacao.apiLegado;
    const response = await api.put(`transferencia-estoque/${id}`, {
      descricao,
    });

    return response;
  },
};

export const transferencia = {
  actions,
  namespaced: true,
};
